import "./TheStudio.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheCreativeEngine from "./sections/TheCreativeEngine";
import TheVisionaries from "./sections/TheVisionaries";
import StudioFooter from "@/reusable_sections/Footer";
export default function TheStudioPage() {
  return <div>
      <MainNavigation />
      <TheCreativeEngine />
      <TheVisionaries />
      <StudioFooter />
    </div>;
}